<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Webshop oldalszerkesztő</ion-title>
    <ion-buttons slot="end">
      <ion-button routerLink="/webshop-admin/catalog" fill="clear">
        <ion-icon slot="start" name="storefront-outline"></ion-icon>
        Termékek
      </ion-button>
      <ion-button [href]="previewUrl" target="_blank" fill="clear">
        <ion-icon slot="start" name="open-outline"></ion-icon>
        Előnézet
      </ion-button>
      <ion-button color="success" (click)="saveAll()" [disabled]="saving || loading">
        <ion-icon slot="start" name="save-outline"></ion-icon>
        Mentés
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="webshop-admin">
  <section class="hero">
    <div>
      <p class="eyebrow">WEBSHOP alrendszer</p>
      <h1>Oldalak szerkesztése adatbázisból</h1>
      <p>
        A publikus webshop továbbra is a backendből renderelődik, de a fő blokkok tartalma már tenant alapján,
        adatbázisból jön. Így ügyfelenként külön szöveg, kép és CTA állítható be.
      </p>
    </div>
    <ion-icon name="color-wand-outline"></ion-icon>
  </section>

  <ion-card class="workspace-card">
    <ion-card-header>
      <ion-card-title>Ügyféloldal szerkesztő</ion-card-title>
      <ion-card-subtitle>{{ tenantCode }} tenant tartalma</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-spinner *ngIf="loading"></ion-spinner>
      <ion-text color="danger" *ngIf="error">{{ error }}</ion-text>

      <div class="editor-layout" *ngIf="!loading && !error">
        <aside class="page-list">
          <div class="page-list-header">
            <span>Oldalak</span>
            <ion-badge color="light">{{ pageTabs.length }}</ion-badge>
          </div>

          <div class="page-dropzone" cdkDropList [cdkDropListData]="pages" (cdkDropListDropped)="dropPage($event)">
            <button
              type="button"
              class="page-button"
              *ngFor="let page of pageTabs"
              cdkDrag
              [class.active]="selectedPage === page.key"
              (click)="selectPage(page)"
            >
              <ion-icon [name]="page.icon"></ion-icon>
              <span>
                <strong>{{ page.label }}</strong>
                <small>{{ page.path }}</small>
              </span>
              <ion-badge color="medium">
                {{ countPageActiveSections(page.key) }}
              </ion-badge>
            </button>
          </div>

          <ion-button expand="block" fill="outline" (click)="addSection()">
            <ion-icon slot="start" name="add-outline"></ion-icon>
            Új blokk
          </ion-button>

          <ion-button expand="block" fill="solid" color="tertiary" (click)="addPage()">
            <ion-icon slot="start" name="add-circle-outline"></ion-icon>
            Új oldal
          </ion-button>

          <ion-note class="path">
            Előnézet: {{ previewUrl }}
          </ion-note>
        </aside>

        <main class="section-editor">
          <ion-card class="theme-settings">
            <ion-card-header>
              <ion-card-title>Megjelenés és színek</ion-card-title>
              <ion-card-subtitle>Ezek a színkódok a publikus webshop teljes oldalán érvényesülnek.</ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <div class="theme-layout">
                <div class="form-grid">
                  <ion-input
                    class="full"
                    label="Webshop neve"
                    label-placement="stacked"
                    fill="outline"
                    [(ngModel)]="themeSettings.name"
                  ></ion-input>

                  <div class="theme-toggle full">
                    <div>
                      <strong>Sötét téma</strong>
                      <small>Ha be van kapcsolva, a publikus webshop sötét alapfelületet használ.</small>
                    </div>
                    <ion-toggle [(ngModel)]="themeSettings.dark_mode"></ion-toggle>
                  </div>

                  <label class="color-field">
                    <span>Fő szín</span>
                    <input type="color" [(ngModel)]="themeSettings.primary_color">
                    <ion-input fill="outline" [(ngModel)]="themeSettings.primary_color"></ion-input>
                  </label>

                  <label class="color-field">
                    <span>Akcentus szín</span>
                    <input type="color" [(ngModel)]="themeSettings.accent_color">
                    <ion-input fill="outline" [(ngModel)]="themeSettings.accent_color"></ion-input>
                  </label>

                  <label class="color-field">
                    <span>Háttér szín</span>
                    <input type="color" [(ngModel)]="themeSettings.background_color">
                    <ion-input fill="outline" [(ngModel)]="themeSettings.background_color"></ion-input>
                  </label>

                  <label class="color-field">
                    <span>Kártya / papír szín</span>
                    <input type="color" [(ngModel)]="themeSettings.paper_color">
                    <ion-input fill="outline" [(ngModel)]="themeSettings.paper_color"></ion-input>
                  </label>

                  <label class="color-field full">
                    <span>Szöveg szín</span>
                    <input type="color" [(ngModel)]="themeSettings.text_color">
                    <ion-input fill="outline" [(ngModel)]="themeSettings.text_color"></ion-input>
                  </label>

                  <div class="payment-settings full">
                    <div class="payment-settings-header">
                      <div>
                        <strong>OTP SimplePay fizetés</strong>
                        <small>Online bankkártyás fizetés a publikus webshop rendelési folyamatában.</small>
                      </div>
                      <ion-toggle [(ngModel)]="themeSettings.simplepay_enabled"></ion-toggle>
                    </div>

                    <div class="theme-toggle">
                      <div>
                        <strong>Sandbox mód</strong>
                        <small>Bekapcsolva a sandbox.simplepay.hu, kikapcsolva az éles secure.simplepay.hu végpontot használja.</small>
                      </div>
                      <ion-toggle [(ngModel)]="themeSettings.simplepay_sandbox"></ion-toggle>
                    </div>

                    <ion-input
                      label="Sandbox kereskedői azonosító"
                      label-placement="stacked"
                      fill="outline"
                      [(ngModel)]="themeSettings.simplepay_sandbox_merchant"
                    ></ion-input>

                    <ion-input
                      label="Sandbox SECRET_KEY"
                      label-placement="stacked"
                      fill="outline"
                      type="password"
                      [placeholder]="themeSettings.simplepay_has_sandbox_secret ? 'Mentett secret megtartása' : 'Sandbox secret megadása'"
                      [(ngModel)]="themeSettings.simplepay_sandbox_secret"
                    ></ion-input>

                    <ion-input
                      label="Éles kereskedői azonosító"
                      label-placement="stacked"
                      fill="outline"
                      [(ngModel)]="themeSettings.simplepay_live_merchant"
                    ></ion-input>

                    <ion-input
                      label="Éles SECRET_KEY"
                      label-placement="stacked"
                      fill="outline"
                      type="password"
                      [placeholder]="themeSettings.simplepay_has_live_secret ? 'Mentett secret megtartása' : 'Éles secret megadása'"
                      [(ngModel)]="themeSettings.simplepay_live_secret"
                    ></ion-input>
                  </div>
                </div>

                <div
                  class="theme-preview"
                  [class.dark-preview]="themeSettings.dark_mode"
                  [style.background]="themeSettings.dark_mode ? '#0d1311' : themeSettings.background_color"
                  [style.color]="themeSettings.dark_mode ? '#f6efe4' : themeSettings.text_color"
                >
                  <div class="preview-card" [style.background]="themeSettings.dark_mode ? '#151a18' : themeSettings.paper_color">
                    <span class="preview-pill" [style.background]="themeSettings.accent_color">Akció</span>
                    <h3>{{ themeSettings.name || 'Webshop' }}</h3>
                    <p>Így fog hatni a választott színvilág a publikus webshop felületén.</p>
                    <button type="button" [style.background]="themeSettings.primary_color">
                      Kosárba
                    </button>
                  </div>
                </div>
              </div>
            </ion-card-content>
          </ion-card>

          <div class="section-toolbar">
            <div>
              <p class="eyebrow muted">Aktív oldal</p>
              <h2>{{ currentPage?.label || selectedPage }}</h2>
              <p>{{ currentPage?.description || 'Egyedi webshop oldal' }}</p>
            </div>
            <div class="toolbar-actions">
              <ion-badge color="success">{{ activeSectionsCount }} aktív blokk</ion-badge>
              <ion-button fill="clear" size="small" [href]="previewUrl" target="_blank">
                <ion-icon slot="start" name="open-outline"></ion-icon>
                Oldal megnyitása
              </ion-button>
            </div>
          </div>

          <ion-card class="page-settings" *ngIf="selectedPageModel">
            <ion-card-header>
              <ion-card-title>Oldal beállításai</ion-card-title>
              <ion-card-subtitle>A checkout/pénztár nem szerepel itt, mert az kódszintű folyamat.</ion-card-subtitle>
            </ion-card-header>
            <ion-card-content>
              <div class="form-grid">
                <ion-input
                  label="Oldal kulcs"
                  label-placement="stacked"
                  fill="outline"
                  [(ngModel)]="selectedPageModel.key"
                  (ionBlur)="updateCurrentPageKey()"
                ></ion-input>

                <ion-input
                  label="URL útvonal"
                  label-placement="stacked"
                  fill="outline"
                  [(ngModel)]="selectedPageModel.path"
                  (ionBlur)="updateCurrentPageKey()"
                ></ion-input>

                <ion-input
                  label="Menü felirat"
                  label-placement="stacked"
                  fill="outline"
                  [(ngModel)]="selectedPageModel.label"
                ></ion-input>

                <ion-input
                  label="Ikon"
                  label-placement="stacked"
                  fill="outline"
                  placeholder="document-text-outline"
                  [(ngModel)]="selectedPageModel.icon"
                ></ion-input>

                <ion-select
                  label="Szülő menüpont"
                  label-placement="stacked"
                  fill="outline"
                  [(ngModel)]="selectedPageModel.parent_key"
                >
                  <ion-select-option value="">Felső szintű menüpont</ion-select-option>
                  <ion-select-option *ngFor="let parentPage of getParentPageOptions(selectedPageModel)" [value]="parentPage.key || parentPage.page_key">
                    {{ parentPage.label || parentPage.key || parentPage.page_key }}
                  </ion-select-option>
                </ion-select>

                <ion-textarea
                  class="full"
                  label="Leírás az adminban"
                  label-placement="stacked"
                  fill="outline"
                  autoGrow="true"
                  [(ngModel)]="selectedPageModel.description"
                ></ion-textarea>
              </div>

              <div class="page-settings-actions">
                <ion-toggle [(ngModel)]="selectedPageModel.featured">Kiemelt menüpont</ion-toggle>
                <ion-button color="danger" fill="outline" size="small" (click)="deleteCurrentPage()" [disabled]="pageTabs.length <= 1">
                  <ion-icon slot="start" name="trash-outline"></ion-icon>
                  Oldal törlése
                </ion-button>
              </div>
            </ion-card-content>
          </ion-card>

          <div
            class="sections-dropzone"
            cdkDropList
            [cdkDropListData]="visibleSections"
            (cdkDropListDropped)="dropSection($event)"
          >
            <ion-card
              class="section-card"
              *ngFor="let section of visibleSections"
              cdkDrag
              [class.section-disabled]="!isSectionActive(section)"
            >
              <ion-card-header>
                <div class="section-head">
                  <button type="button" class="drag-handle" cdkDragHandle title="Blokk átrendezése">
                    <ion-icon name="reorder-three-outline"></ion-icon>
                  </button>
                  <div>
                    <ion-card-title>
                      {{ section.section_key || 'Névtelen blokk' }}
                      <ion-badge color="medium">{{ section.page_key }}</ion-badge>
                    </ion-card-title>
                    <ion-card-subtitle>Sorrend: {{ section.sort_order }}</ion-card-subtitle>
                  </div>
                </div>

                <div class="section-actions">
                  <ion-button fill="clear" size="small" (click)="duplicateSection(section)">
                    <ion-icon slot="start" name="copy-outline"></ion-icon>
                    Másolás
                  </ion-button>
                  <ion-button fill="clear" size="small" color="medium" (click)="toggleSection(section)">
                    <ion-icon slot="start" [name]="isSectionActive(section) ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                    {{ isSectionActive(section) ? 'Elrejtés' : 'Aktiválás' }}
                  </ion-button>
                </div>
              </ion-card-header>

              <ion-card-content>
                <div class="form-grid">
                  <ion-input
                    label="Blokk kulcs"
                    label-placement="stacked"
                    fill="outline"
                    [(ngModel)]="section.section_key"
                  ></ion-input>

                  <ion-input
                    label="Sorrend"
                    type="number"
                    label-placement="stacked"
                    fill="outline"
                    [(ngModel)]="section.sort_order"
                  ></ion-input>

                  <ion-toggle [(ngModel)]="section.active">Aktív</ion-toggle>

                  <ion-toggle
                    *ngIf="section.page_key === 'home' && section.section_key === 'categories'"
                    [ngModel]="ensureSectionExtra(section).show_all_products_category"
                    (ngModelChange)="ensureSectionExtra(section).show_all_products_category = $event ? 1 : 0"
                  >
                    “Minden termék” kategória megjelenítése
                  </ion-toggle>

                  <ion-input
                    class="full"
                    label="Cím"
                    label-placement="stacked"
                    fill="outline"
                    [(ngModel)]="section.title"
                  ></ion-input>

                  <ion-textarea
                    class="full"
                    label="Alcím / rövid szöveg"
                    label-placement="stacked"
                    fill="outline"
                    autoGrow="true"
                    [(ngModel)]="section.subtitle"
                  ></ion-textarea>

                  <ion-textarea
                    class="full"
                    label="Hosszabb tartalom"
                    label-placement="stacked"
                    fill="outline"
                    autoGrow="true"
                    [(ngModel)]="section.body"
                  ></ion-textarea>

                  <ion-input
                    label="Gomb felirata"
                    label-placement="stacked"
                    fill="outline"
                    [(ngModel)]="section.button_label"
                  ></ion-input>

                  <ion-input
                    label="Gomb útvonala"
                    label-placement="stacked"
                    fill="outline"
                    placeholder="termekek"
                    [(ngModel)]="section.button_route"
                  ></ion-input>

                  <div class="image-field full">
                    <div class="image-preview" *ngIf="section.image_url; else noSectionImage">
                      <img [src]="imagePreviewUrl(section.image_url)" [alt]="section.title || section.section_key || 'Blokk kép'">
                    </div>
                    <ng-template #noSectionImage>
                      <div class="image-preview empty">
                        <ion-icon name="image-outline"></ion-icon>
                        <span>Nincs kép feltöltve</span>
                      </div>
                    </ng-template>

                    <div class="image-controls">
                      <ion-input
                        label="Kép URL"
                        label-placement="stacked"
                        fill="outline"
                        placeholder="/api/webshop/assets/webshop-assets/misc/fooldal.jpg"
                        [(ngModel)]="section.image_url"
                      ></ion-input>

                      <label class="upload-button">
                        <input type="file" accept="image/*" (change)="uploadSectionImage($event, section)">
                        <ion-icon name="cloud-upload-outline"></ion-icon>
                        <span>{{ isUploadingSectionImage(section) ? 'Feltöltés...' : 'Kép tallózása' }}</span>
                      </label>

                      <ion-button fill="clear" size="small" [href]="imagePreviewUrl(section.image_url)" target="_blank" [disabled]="!section.image_url">
                        <ion-icon slot="start" name="open-outline"></ion-icon>
                        Megnyitás
                      </ion-button>

                      <ion-toggle
                        [ngModel]="ensureSectionExtra(section).image_background"
                        (ngModelChange)="ensureSectionExtra(section).image_background = $event"
                      >
                        Kép háttérként
                      </ion-toggle>

                      <ion-input
                        *ngIf="ensureSectionExtra(section).image_background"
                        label="Háttér gradient overlay"
                        label-placement="stacked"
                        fill="outline"
                        placeholder="linear-gradient(90deg, rgba(0, 0, 0, .25), rgba(0, 0, 0, 0))"
                        [ngModel]="ensureSectionExtra(section).background_gradient"
                        (ngModelChange)="ensureSectionExtra(section).background_gradient = $event"
                      ></ion-input>
                    </div>
                  </div>
                </div>
              </ion-card-content>
            </ion-card>
          </div>

          <div class="empty-page" *ngIf="!visibleSections.length">
            <ion-icon name="albums-outline"></ion-icon>
            <h3>Ezen az oldalon még nincs szerkeszthető blokk</h3>
            <p>Hozz létre egy új blokkot, és mentés után az adatbázisból fog renderelődni.</p>
            <ion-button (click)="addSection()">
              <ion-icon slot="start" name="add-outline"></ion-icon>
              Első blokk hozzáadása
            </ion-button>
          </div>
        </main>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>
